"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatter = void 0;
const constants_1 = require("./utils/constants");
class PriceFormatter {
    config;
    #integerNumberFormat;
    #decimalNumberFormat;
    locale;
    constructor(config) {
        this.config = config;
        this.#integerNumberFormat = new Intl.NumberFormat(config?.locale ?? constants_1.FALLBACK_LOCALE, Object.assign({}, constants_1.DEFAULT_CURRENCY_INTEGER_NUMBER_FORMAT, config?.integerNumberFormat));
        this.#decimalNumberFormat = new Intl.NumberFormat(config?.locale ?? constants_1.FALLBACK_LOCALE, Object.assign({}, constants_1.DEFAULT_CURRENCY_DECIMAL_NUMBER_FORMAT, config?.decimalNumberFormat));
        this.locale = config?.locale || constants_1.FALLBACK_LOCALE;
    }
    getFormattedPrice(price) {
        return price % 1 === 0 ? this.#integerNumberFormat.format(price) : this.#decimalNumberFormat.format(price);
    }
    getCurrencySymbol(currencyCode) {
        const currencyFormat = new Intl.NumberFormat(this.locale, {
            style: "currency",
            currency: currencyCode,
        });
        const parts = currencyFormat.formatToParts(0);
        return parts.find((part) => part.type === "currency")?.value || "";
    }
}
exports.PriceFormatter = PriceFormatter;
